/** Persist past browser restart; omitting Max-Age creates a session-only cookie. */
export const MANAGE_TABLE_COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 400;

export const getCookieNameFromKey = (key) =>
  `manage_table_${`${key}`.replace(/[^a-zA-Z0-9_-]/g, "_")}`;

export const getCookieValue = (name) => {
  if (typeof document === "undefined") return null;
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  if (!cookie) return null;
  return decodeURIComponent(cookie.split("=")[1] || "");
};

export const setCookieValue = (name, value) => {
  if (typeof document === "undefined") return;
  const secure =
    typeof window !== "undefined" && window.location?.protocol === "https:"
      ? "; Secure"
      : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax; Max-Age=${MANAGE_TABLE_COOKIE_MAX_AGE_SEC}${secure}`;
};

/**
 * @param {Record<string, Record<string, boolean>>} manageTables storageKey -> column visibility map
 * @param {{ skipIfCookieExists?: boolean }} options
 */
export const applyManageTablesToCookies = (manageTables, options = {}) => {
  if (!manageTables || typeof manageTables !== "object") return;
  const { skipIfCookieExists = false } = options;
  Object.entries(manageTables).forEach(([storageKey, visibilityMap]) => {
    if (!storageKey || typeof visibilityMap !== "object" || visibilityMap === null) return;
    const cookieName = getCookieNameFromKey(storageKey);
    if (skipIfCookieExists) {
      const existing = getCookieValue(cookieName);
      if (existing != null && String(existing).trim() !== "") return;
    }
    setCookieValue(cookieName, JSON.stringify(visibilityMap));
  });
};

/**
 * After login or /auth/me: seed manage_table_* from the server only when the browser
 * has no value yet, so Logout/Login does not clear column preferences stored in cookies.
 */
export const applyUserPerfCookiesFromAuthUser = (user) => {
  const tables = user?.user_perf?.manage_tables;
  applyManageTablesToCookies(tables, { skipIfCookieExists: true });
};
